export default __webpack_public_path__ + "static/media/TCD.519688fe.webp";